import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Login } from './views/Login';
import { Customers } from './views/Customers';
import { TruckHorses } from './views/TruckHorses';
import { TruckTraylers } from './views/TruckTraylers';
import { Devices } from './views/Devices';
import { DeviceStatus } from './views/DeviceStatus';
import { DeviceType } from './views/DeviceType';
import { TruckHorseType } from './views/TruckHorseType';
import { TruckTraylerType } from './views/TruckTraylerType';
import { Users } from './views/Users';
import { Reports } from './views/Reports';
import { GeneralDashboard } from './views/GeneralDashboard';
import { QRNFCScanner } from './views/QRNFCScanner';
import './App.css';
import { ConfigProvider } from 'antd';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
      <div className='logo-text' style={{ padding: 16, color: 'black', textAlign: 'center', fontWeight: 'bold' }}>
        ZETEK
      </div>
      <div style={{ marginTop: 5 }}>
        <i
        className="fa fa-spinner"
        style={{ color: '#1976d2', animationDuration: '0.6s' }}
        aria-label="Loading"
        ></i>
      </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && !user.isAdmin) {
    return <Navigate to="/" />;
  }

  return children;
};

const App = () => {
  return (
    <AuthProvider>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#18568E',
          },
        }}
      >
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <GeneralDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/truck_horses"
              element={
                <PrivateRoute>
                  <TruckHorses />
                </PrivateRoute>
              }
            />
            <Route
              path="/truck_traylers"
              element={
                <PrivateRoute>
                  <TruckTraylers />
                </PrivateRoute>
              }
            />
            <Route
              path="/devices"
              element={
                <PrivateRoute>
                  <Devices />
                </PrivateRoute>
              }
            />
            <Route
              path="/customers"
              element={
                <PrivateRoute adminOnly={true}>
                  <Customers />
                </PrivateRoute>
              }
            />
            <Route
              path="/device_status"
              element={
                <PrivateRoute adminOnly={true}>
                  <DeviceStatus />
                </PrivateRoute>
              }
            />
            <Route
              path="/device_type"
              element={
                <PrivateRoute adminOnly={true}>
                  <DeviceType />
                </PrivateRoute>
              }
            />
            <Route
              path="/truck_horse_type"
              element={
                <PrivateRoute adminOnly={true}>
                  <TruckHorseType />
                </PrivateRoute>
              }
            />
            <Route
              path="/truck_trayler_type"
              element={
                <PrivateRoute adminOnly={true}>
                  <TruckTraylerType />
                </PrivateRoute>
              }
            />            <Route
              path="/users"
              element={
                <PrivateRoute adminOnly={true}>
                  <Users />
                </PrivateRoute>
              }
            />            <Route
              path="/reports"
              element={
                <PrivateRoute>
                  <Reports />
                </PrivateRoute>
              }
            />
            <Route
              path="/qr-nfc-scanner"
              element={
                <PrivateRoute>
                  <QRNFCScanner />
                </PrivateRoute>
              }
            />
            <Route
              path="/general_dashboard"
              element={
                <PrivateRoute>
                  <GeneralDashboard />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </ConfigProvider>
    </AuthProvider>
  );
};

export default App;